module.exports = __webpack_public_path__ + "img/sectionaparaquienes.0b81601f.svg";